import React, { FC, HTMLAttributes } from 'react';
import { cn } from '../../helpers';
import styles from './backdrop.module.scss';

/**
 * Backdrop
 *
 * Usually this is a utility component and should only be used in combination with other components
 */
export const Backdrop: FC<HTMLAttributes<HTMLElement>> = ({ children, className, ...props }) => {
    const backdropClasses = cn(styles.backdrop, {
        [className]: className,
    });

    return (
        <div className={backdropClasses} {...props}>
            {children}
        </div>
    );
};
